export default __webpack_public_path__ + "static/media/icon_braintree_apple.fd67d15e.png";